import { Fragment, useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Badge,
} from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMemberBenefitForCust, getAllMemberBenefitForCustomer, resetMemberBenefits, setCustomer } from "../../../store/slices/customers";
import { useNavigate } from "react-router";
import Papa from "papaparse";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import { get } from "react-hook-form";
import API from "../../../api/baseApi"
import { getAccessToken } from "../../../api/baseApi";
import * as XLSX from "xlsx";
import { CUSTOMER_FIELDS } from "./customerFields";
import axios from "axios";

const CustomersTableMB = () => {
  const [csv, setCsv] = useState(null);
  const inputRef = useRef(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const history = useNavigate();
  const id = window.location.pathname.split("/").pop();
  const layout = id;
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const [totalCount, setCount] = useState(0);
  
  const [showMappingModal, setShowMappingModal] = useState(false);
  const [uploadedHeaders, setUploadedHeaders] = useState([]);
  const [fieldMapping, setFieldMapping] = useState({}); 
  const [mappingErrors, setMappingErrors] = useState({});

  const [showBenefitsModal, setShowBenefitsModal] = useState(false);
  const [selectedBenefitDetails, setSelectedBenefitDetails] = useState(null);

  const [summaryDataArray , setSummaryDataArray ] = useState(null);

  const { customers, count } = useSelector(
    (state) => state.customers.customers
  );

   const customersMBData = useSelector(
    (state) => state.customers.customersMBData
  );
  
  const client = useSelector((state) => state.clients.selectedClient.value);
  const [isLoading,setIsLoading] = useState(false)
  const permissions = useSelector((state) => state.auth.permissions);
  const userRole = useSelector((state) => state.auth.user.role);
  const [isTemplateDownloadLoading,setIsTemplateDownloadLoading] = useState(false)
  const [isPreview,setIsPreview] = useState(false)
  const tenantClientData = useSelector(state => state.clients)

  const UploadAllowTenant = [
    'hc',
    'ebix'
  ]

  useEffect(() => {
    getCustomers();
  }, [client, 
    // pagination, 
    // globalFilter
  ]);

  useEffect(() => {
    setData(customersMBData || []);
    // setCount(count);
  }, [customersMBData]);

  const getCustomers = async () => {
    dispatch(
      getMemberBenefitForCust({
        sortByCust:true
        // pagination: true,
        // limit: pagination.pageSize,
        // offset: pagination.pageSize * pagination.pageIndex,
        // search: globalFilter || undefined,
      })
    );
  };

  const handleResetBenefits = async (event, rowData) => {
    event.stopPropagation(); 
    // setSelectedBenefitDetails(rowData);
    // setShowBenefitsModal(true);
    let result = await dispatch(
      resetMemberBenefits({
        customer_id: rowData.Customer?.id || rowData.customer_id, 
      })
    );
    // console.log(result,"RESULTTt");
    getMemberBenefitForCust({
      sortByCust:true
    })
  };

  const handleSummary = async (event, rowData) => {
    event.stopPropagation(); 
    
    let result = await dispatch(
      getAllMemberBenefitForCustomer({
        customer_id: rowData.Customer?.id || rowData.customer_id, 
        subscription_id: rowData.subscription_id 
      })
    );
    console.log(result,"RESULTTt");
    setSelectedBenefitDetails(rowData);
    setSummaryDataArray(result?.payload);
    setShowBenefitsModal(true);
  };

  const toggleBenefitsModal = () => {
    setShowBenefitsModal(!showBenefitsModal);
    if (showBenefitsModal) {
      setSelectedBenefitDetails(null);
      setSummaryDataArray(null); 
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "Customer.email",
        header: "Email",
        size: 150,
      },
      {
        accessorKey: "master_benefit_id",
        id: "reset_benefits",
        header: "Member Benefits",
        size: 100,
        Cell: ({ row }) => (
          <Button
            color="primary"
            size="sm"
            onClick={(e) => handleResetBenefits(e, row.original)}
          >
            Reset
          </Button>
        ),
      },
      {
        accessorKey: "master_benefit_id",
        id: "view_summary",
        header: "View Summary",
        size: 100,
        Cell: ({ row }) => (
          <Button
            color="primary"
            size="sm"
            onClick={(e) => handleSummary(e, row.original)}
          >
            View
          </Button>
        ),
      },
    ],
    []
  );

  const rowAction = (event, row) => {
    console.log(event, row);
    dispatch(setCustomer(row.original));
    history(`/app/contact-app/contacts`);
  };

  const handlePageChange = (event) => {
    setPagination(event);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => rowAction(event, row),
      sx: {
        cursor: "pointer",
      },
    }),
    manualPagination: true,
    manualFiltering: true,
    rowCount: totalCount,
    onPaginationChange: (event) => handlePageChange(event),
    onGlobalFilterChange: setGlobalFilter,
    state: { pagination, globalFilter },
    initialState: { density: "compact" },
  });

  useEffect(() => {
    getMemberBenefitForCust({
      sortByCust:true
      // pagination: true,
      // limit: pagination.pageSize,
      // offset: pagination.pageSize * pagination.pageIndex,
    });
  }, []);

 
  const parseExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
          if (jsonData?.length === 0) {
            reject(new Error("Excel file is empty"));
            return;
          }
          
          const headers = jsonData[0].map((h) => String(h || "").trim()).filter((h) => h);
          const rows = jsonData.slice(1).map((row) => {
            const obj = {};
            headers.forEach((header, index) => {
              obj[header] = row[index] !== undefined ? String(row[index] || "").trim() : "";
            });
            return obj;
          }).filter((row) => Object.values(row).some((v) => v));
          
          resolve({ headers, data: rows });
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };

 
  const parseCSVFile = (file) => {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        transform: (value) => {
          return typeof value === "string" ? value.trim() : value;
        },
        complete: (results) => {
          if (results?.errors?.length > 0 && results?.data?.length === 0) {
            reject(new Error("Error parsing CSV file"));
            return;
          }
          const headers = Object.keys(results.data[0] || {});
          resolve({ headers, data: results.data });
        },
        error: reject,
      });
    });
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("File size should be less than 5MB");
      if (inputRef.current) inputRef.current.value = "";
      setCsv(null);
      return;
    }

    const isCSV = file.type === "text/csv" || file.name.endsWith(".csv");
    const isExcel = 
      file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel" ||
      file.name.endsWith(".xlsx") ||
      file.name.endsWith(".xls");

    if (!isCSV && !isExcel) {
      toast.error("Please upload a valid CSV or Excel file (.csv, .xlsx, .xls)");
      if (inputRef.current) inputRef.current.value = "";
      setCsv(null);
      return;
    }

    try {
      setCsv(file);
      setError(null);
      
      let result;
      if (isCSV) {
        result = await parseCSVFile(file);
      } else {
        result = await parseExcelFile(file);
      }

      if (result?.data?.length > 1001) {
        toast.error("Please upload a file with less than 1000 records.");
        if (inputRef.current) inputRef.current.value = "";
        setCsv(null);
        return;
      }

      setUploadedHeaders(result.headers);

      const initialMapping = {};
      CUSTOMER_FIELDS.forEach((field) => {
        if(result?.headers?.includes(field.key)){
            initialMapping[field?.key] = field?.key
        }else{
          initialMapping[field.key] = "";
        }
      });
      setFieldMapping(initialMapping);
      setMappingErrors({});
      
      setShowMappingModal(true);
    } catch (error) {
      toast.error(`Error parsing file: ${error.message}`);
      if (inputRef.current) inputRef.current.value = "";
      setCsv(null);
    }
  };

  const getSortedCustomerFields = () => {
    const requiredFields = CUSTOMER_FIELDS.filter((field) => field.required);
    const optionalFields = CUSTOMER_FIELDS.filter((field) => !field.required);
    return [...requiredFields, ...optionalFields];
  };

  const getAvailableUploadedHeaders = (currentDatabaseField) => {
    const currentMappedHeader = fieldMapping[currentDatabaseField] || "";

    const allMappedHeaders = Object.entries(fieldMapping)
      .filter(([_, header]) => header) 
      .map(([_, header]) => header);

    return uploadedHeaders.filter((header) => {
      if (header === currentMappedHeader) {
        return true;
      }
      return !allMappedHeaders.includes(header);
    });
  };

  const handleMappingChange = (databaseField, uploadedHeader) => {
    setFieldMapping((prev) => ({
      ...prev,
      [databaseField]: uploadedHeader,
    }));
    
    if (mappingErrors[databaseField]) {
      setMappingErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[databaseField];
        return newErrors;
      });
    }
  };

  const validateMapping = () => {
    const errors = {};
    const requiredFields = CUSTOMER_FIELDS.filter((field) => field.required);
    
    requiredFields.forEach((field) => {
      const mappedUploadedHeader = fieldMapping[field.key];
      if (!mappedUploadedHeader || mappedUploadedHeader === "") {
        errors[field.key] = `${field.label} is required but not mapped`;
      }
    });

    setMappingErrors(errors);
    return Object?.keys(errors)?.length === 0;
  };

  const handleFinalUpload = async () => {
    if (!validateMapping()) {
      toast.error("Please map all required fields before uploading.");
      return;
    }

     if (!csv) {
      toast.error("No file selected.");
      return;
    }

    setIsLoading(true)
    try {
      const formData = new FormData();
      formData.append("files", csv);
      formData.append("mappingJson", JSON.stringify(fieldMapping));

      const response = await axios.post(
        `${process.env.REACT_APP_PL_API}/customers/bulkupload_user-new`,
        formData,
        {
          headers: {
            "x-tenant-id": client,
            "x-access-token": getAccessToken(client),
          },
          maxBodyLength: Infinity,
          maxContentLength: Infinity,
          responseType: "blob",
        }
      );
      
      saveAs(response.data, "upload_result.csv");
      setCsv(null);
      setShowMappingModal(false);
      setFieldMapping({});
      setUploadedHeaders([]);
      if (inputRef.current) inputRef.current.value = "";
      toast.success("File uploaded and result downloaded successfully");
      
      getCustomers();
    } catch (error) {
      toast.error(`Error uploading file: ${error.message}`);
    }finally{
      setIsLoading(false)
    }
  };

  const handleCloseMappingModal = () => {
    setShowMappingModal(false);
    setCsv(null);
    setFieldMapping({});
    setUploadedHeaders([]);
    setMappingErrors({});
    setIsPreview(false)
    if (inputRef.current) inputRef.current.value = "";
  };

  const handleDownloadTemplate = ()=>{
    setIsTemplateDownloadLoading(true)
    try{
        const csvContent = CUSTOMER_FIELDS?.map(el => el?.key).join(","); 
        const filename = "Get-Template.csv";
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
        saveAs(blob, filename);
    }catch{

    }finally{
      setIsTemplateDownloadLoading(false)
    }
  }

  const handlePreviewBack = ()=>{
    setIsPreview(false)
  }

  
  const renderMBDetails = (details) => {
    if (!details) return null;
    return (
      <div className="bg-light p-3 rounded mt-2 mb-3 border">
        <Row className="text-center mb-2">
          <Col xs="3"><Badge color="primary" className="p-2 w-100">Total: {details.total}</Badge></Col>
          <Col xs="3"><Badge color="danger" className="p-2 w-100">Used: {details.used}</Badge></Col>
          <Col xs="3"><Badge color="success" className="p-2 w-100">Unused: {details.unused}</Badge></Col>
          {/* <Col xs="3"><Badge color="info" className="p-2 w-100">Amount: {details.benefit_amount}</Badge></Col> */}
        </Row>
        <div className="d-flex justify-content-between text-muted" style={{ fontSize: '0.85rem' }}>
          <span><strong>Type:</strong> <span className="text-capitalize">{details.benefit_type}</span></span>
          <span><strong>Mode:</strong> <span className="text-capitalize">{details.benefit_mode}</span></span>
          <span><strong>Value Type:</strong> <span className="text-capitalize">{details.value_benefit_type}</span></span>
        </div>
      </div>
    );
  };

  const renderBenefitNode = (nodeName, nodeData, isRoot = false) => {
    const subServices = nodeData.sub_services || [];
    const categories = nodeData.categories || [];
    const subCategories = nodeData.sub_categories || [];

    return (
      <div className={`mt-3 ${!isRoot ? 'ms-4 border-start border-2 border-primary border-opacity-25 ps-3' : ''}`}>
        <div className="d-flex align-items-center mb-1">
          <h6 className="mb-0 fw-bold text-dark me-2">
            {nodeName || nodeData.service_name || nodeData.sub_service_name || nodeData.category_name || nodeData.sub_category_name}
          </h6>
          {nodeData.type && <Badge color="secondary">{nodeData.type}</Badge>}
        </div>
        
        {nodeData.description && <p className="text-muted small mb-2">{nodeData.description}</p>}

        {renderMBDetails(nodeData.mb_details)}

        {subServices.length > 0 && (
          <div className="mt-3">
            <strong className="text-uppercase text-muted small" style={{letterSpacing: '1px'}}>Sub Services</strong>
            {subServices.map((sub, idx) => <Fragment key={`sub-${idx}`}>{renderBenefitNode(sub.sub_service_name, sub)}</Fragment>)}
          </div>
        )}
        {categories.length > 0 && (
          <div className="mt-3">
            <strong className="text-uppercase text-muted small" style={{letterSpacing: '1px'}}>Categories</strong>
            {categories.map((cat, idx) => <Fragment key={`cat-${idx}`}>{renderBenefitNode(cat.category_name, cat)}</Fragment>)}
          </div>
        )}
        {subCategories.length > 0 && (
          <div className="mt-3">
            <strong className="text-uppercase text-muted small" style={{letterSpacing: '1px'}}>Sub Categories</strong>
            {subCategories.map((subCat, idx) => <Fragment key={`subcat-${idx}`}>{renderBenefitNode(subCat.sub_category_name, subCat)}</Fragment>)}
          </div>
        )}
      </div>
    );
  };
 
 
  return (
    <Fragment>
      <Breadcrumbs mainTitle="Customers Member Benefits" parent="Customers" parentPath="customers-member-benefit" title="Customers Member Benefit" />
      <Container fluid={true}>
        {
          UploadAllowTenant?.includes(tenantClientData?.selectedClient?.value) && (
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label for="csvFile">Upload CSV</Label>
                      <Input
                        type="file"
                        id="csvFile"
                        accept=".csv,.xlsx,.xls"
                        onChange={handleFileChange}
                        innerRef={inputRef}
                      />
                      <small className="form-text text-muted">
                        Supported formats: CSV. Max file size: 5MB. Max records: 1000.
                      </small>
                    </FormGroup>
                    {error && <Alert color="danger">{error}</Alert>}
                    {success && <Alert color="success">{success}</Alert>}

                    <Button color="info" onClick={handleDownloadTemplate}>
                      {
                        isTemplateDownloadLoading ? "Downloading..." : "Get Template"
                      }
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )
        }
       
        <Modal isOpen={showBenefitsModal} toggle={toggleBenefitsModal} size="xl">
           <ModalHeader className="border-bottom py-3">
            <span className="text-primary fw-bold" style={{ fontSize: '1.25rem', letterSpacing: '0.5px' }}>
              Member Benefit Summary Details
            </span>
          </ModalHeader>
          <ModalBody style={{ maxHeight: '75vh', overflowY: 'auto' }}>
            {selectedBenefitDetails ? (
              <div>
                {/* <Row className="mb-4 bg-white p-4 rounded mx-0 shadow-sm border border-start border-primary border-4 align-items-center">
                  <Col md="7" className="mb-3 mb-md-0">
                    <div className="text-muted small fw-bold text-uppercase mb-1" style={{ letterSpacing: '1px' }}>
                      Customer Email
                    </div>
                    <div className="text-dark fs-5 fw-bolder text-break">
                      {selectedBenefitDetails?.Customer?.email || 'N/A'}
                    </div>
                  </Col>
                  <Col md="5" className="text-md-end">
                    <div className="text-muted small fw-bold text-uppercase mb-2" style={{ letterSpacing: '1px' }}>
                      Master Benefit ID
                    </div>
                    <Badge color="light" className="text-primary border border-primary px-3 py-2 fs-6 rounded-pill shadow-sm">
                      #{selectedBenefitDetails?.master_benefit_id || 'N/A'}
                    </Badge>
                  </Col>
                </Row> */}
                
                {/* <hr className="mb-4" /> */}

                {summaryDataArray && summaryDataArray.length > 0 ? (
                  <div>
                   
                    {/* <h5 className="mb-3 text-primary border-bottom pb-2">Overall Summaries</h5>
                    <Row className="mb-4">
                      {summaryDataArray
                        .filter(obj => Object.keys(obj)[0].endsWith('_Summary'))
                        .map((obj, idx) => {
                          const keyName = Object.keys(obj)[0];
                          const summaryData = obj[keyName];
                          return (
                            <Col md="6" key={`summary-${idx}`}>
                              <Card className="shadow-sm border-0 border-top border-primary border-3 mb-3">
                                <CardBody>
                                  <h6 className="fw-bold mb-3">{keyName.replace('_Summary', '')}</h6>
                                  {renderMBDetails(summaryData)}
                                </CardBody>
                              </Card>
                            </Col>
                          );
                      })}
                    </Row> */}

                    
                    {/* <h5 className="mb-3 text-primary border-bottom pb-2 mt-4">Detailed Service Breakdown</h5> */}
                    {summaryDataArray
                      .filter(obj => !Object.keys(obj)[0].endsWith('_Summary'))
                      .map((obj, idx) => {
                        const serviceName = Object.keys(obj)[0];
                        const serviceData = obj[serviceName];
                        return (
                          <Card key={`service-${idx}`} className="shadow-sm mb-4 border-0 border-start border-info border-4">
                            <CardBody>
                              {renderBenefitNode(serviceName, serviceData, true)}
                            </CardBody>
                          </Card>
                        );
                    })}
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <p className="text-muted">Loading benefits summary or no data available...</p>
                  </div>
                )}
              </div>
            ) : (
              <p>No details available.</p>
            )}
          </ModalBody>
          <ModalFooter className="bg-light">
            <Button color="secondary" onClick={toggleBenefitsModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
        <Row>
          <Col sm="12">
            <Card>
              <MaterialReactTable table={table} />
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CustomersTableMB;